import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { AgentFlag, AgentType } from '@domain-group/fe-allhomes-library';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Separator } from '@domain-group/fe-co-allhomes-design-system';
import { CONTACT_DETAILS, CONTACT_AGENTS } from './utils/const';
import agencyType from './props/agency-type';
import AgentCard from './agent-card';
import PrivateListerCard from './private-lister-card';
import * as styles from './agency-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var allAgenciesArePrivateListers = agencies => !agencies.some(agency => agency.type !== AgentType.PrivateLister.name);
var AgencyDetails = _ref => {
  var agencies = _ref.agencies,
    reiBadges = _ref.reiBadges;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var isPrivateLister = allAgenciesArePrivateListers(agencies);
  var displayHeader = isPrivateLister ? CONTACT_DETAILS : CONTACT_AGENTS;
  var renderAgents = (agency, agents) => agents.map((agent, index) => ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AgentCard, {
    key: agent.name,
    agent: agent,
    agency: agency,
    index: index
  }), ___EmotionJSX(Separator, {
    css: styles.separatorWithMargin
  })));
  var renderPrivateLister = agents => agents.map(agent => ___EmotionJSX(PrivateListerCard, {
    key: agent.name,
    agent: agent
  }));
  var renderReiBadge = flags => {
    if (isEmpty(flags)) {
      return undefined;
    }
    var reiId;
    var badgeLogo;
    if (flags.includes(AgentFlag.REI_LOGO_ACT)) {
      reiId = 'REIACT';
      badgeLogo = reiBadges.act;
    } else if (flags.includes(AgentFlag.REI_LOGO_NSW)) {
      reiId = 'REINSW';
      badgeLogo = reiBadges.nsw;
    }
    return isEmpty(reiId) ? undefined : ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
      css: styles.rei
    }, ___EmotionJSX("div", {
      css: styles.reiText
    }, "Licensed Agent & ", reiId, " Member"), ___EmotionJSX("img", {
      src: badgeLogo,
      alt: reiId
    })));
  };
  var onAgencyProfileClick = (agencyId, agencyName) => {
    sendEvent('agency-enquiry-profile-click', {
      agencyName,
      agencyId
    });
  };
  return ___EmotionJSX("div", {
    css: styles.agencyDetails
  }, ___EmotionJSX("h3", {
    css: styles.heading
  }, displayHeader), ___EmotionJSX("div", null, agencies.map(agency => {
    var _agency$agents = agency.agents,
      agents = _agency$agents === void 0 ? [] : _agency$agents,
      id = agency.id,
      flags = agency.flags,
      logo = agency.logo,
      name = agency.name,
      profileUrl = agency.profileUrl,
      type = agency.type;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
      css: styles.agencyHeader({
        hasRei: flags.includes(AgentFlag.REI_LOGO_ACT) || flags.includes(AgentFlag.REI_LOGO_NSW)
      })
    }, logo && ___EmotionJSX("a", {
      href: profileUrl,
      onClick: () => onAgencyProfileClick(id, name)
    }, ___EmotionJSX("img", {
      css: styles.logo,
      src: logo,
      alt: name
    })), ___EmotionJSX("h4", {
      css: styles.agency
    }, ___EmotionJSX("div", null, name), type !== AgentType.PrivateLister.name && ___EmotionJSX("div", null, ___EmotionJSX("a", {
      css: styles.agencyLink,
      href: profileUrl,
      onClick: () => onAgencyProfileClick(id, name)
    }, "View agency profile")))), renderReiBadge(flags), type === AgentType.PrivateLister.name ? renderPrivateLister(agents) : renderAgents(agency, agents));
  })));
};
AgencyDetails.propTypes = {
  agencies: PropTypes.arrayOf(PropTypes.shape(agencyType)).isRequired,
  reiBadges: PropTypes.shape({
    act: PropTypes.string,
    nsw: PropTypes.string
  })
};
AgencyDetails.defaultProps = {
  reiBadges: {
    act: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-enquiry-form/static/REIACT_e96a5e24.png",
    nsw: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-enquiry-form/static/REINSW_aa2e1f8d.png"
  }
};
export default withEventBoundary('agency-details')(AgencyDetails);